<template>
  <f7-popup id="popup-team" class="popup-team">
    <f7-view>
      <f7-page>
        <f7-block v-if="loading" class="loading-data">
          <f7-preloader></f7-preloader>
        </f7-block>

        <div v-else>
          <f7-block-title large>
            {{ $t(`team`) }}
          </f7-block-title>

          <f7-block-title class="no-margin-top">
            {{ $t(`add_new_member`) }}
          </f7-block-title>
          <f7-list
            class="popup-team-form"
            inset
            form
            @submit.prevent="handleSubmitInvite"
          >
            <f7-list-input
              outline
              type="tel"
              :placeholder="$t(`form_fields.phone_number.placeholder`)"
              :value="phone"
              @input="phone = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
              outline
              type="text"
              :placeholder="$t(`form_fields.name.placeholder`)"
              :value="name"
              @input="name = $event.target.value"
            >
            </f7-list-input>
            <f7-list-input
              outline
              type="email"
              :placeholder="$t(`form_fields.email.placeholder`)"
              :value="email"
              @input="email = $event.target.value"
            >
            </f7-list-input>

            <f7-button
              color="blue"
              class="custome-round"
              fill
              large
              round
              @click.prevent="handleSubmitInvite"
            >
              {{ $t(`add`) }}
            </f7-button>
          </f7-list>

          <f7-block v-if="!teams.length" class="popup-team-empty">
            {{ $t(`no_team`) }}
          </f7-block>

          <div v-if="teams.length" class="data-table">
            <table>
              <thead>
                <tr>
                  <th class="label-cell">Name</th>
                  <th class="numeric-cell">Phone</th>
                  <th class="medium-only">Reg. Date</th>
                  <th class="medium-only">Total</th>
                  <th class="medium-only">Last Credits</th>
                  <th class="medium-only">Balance</th>
                  <th class="medium-only">Send Credits</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="team in teams" :key="team.id">
                  <td class="label-cell">{{ team.name }}</td>
                  <td class="numeric-cell">{{ team.phone }}</td>
                  <td class="medium-only">
                    {{ format(new Date(team.created_at), 'dd.MM.yyyy') }}
                  </td>
                  <td class="medium-only">{{ `${team.balance}$` }}</td>
                  <td class="medium-only">
                    {{
                      team.last_payemnt
                        ? format(new Date(team.last_payemnt), 'dd.MM.yyyy')
                        : '-'
                    }}
                  </td>
                  <td class="medium-only">
                    {{ team.payemnts_sum ? team.payemnts_sum : '-' }}
                  </td>
                  <td class="medium-only">
                    <f7-input
                      type="text"
                      :placeholder="$t(`amount`)"
                      :value="team.amountValue"
                      @input="onPaymentsUpdate(team.id, $event.target.value)"
                    ></f7-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <f7-block v-if="teams.length" class="display-flex">
            <f7-button
              color="blue"
              class="custome-round ml-auto"
              fill
              large
              round
              href="/team-payment-history"
            >
              {{ $t(`payment_history`) }}
            </f7-button>

            <f7-button
              color="purple"
              class="custome-round margin-left"
              fill
              large
              round
              @click="sendCredits"
            >
              {{ $t(`send_credits`) }}
            </f7-button>
          </f7-block>
        </div>
      </f7-page>
    </f7-view>
  </f7-popup>
</template>

<script>
import { format } from 'date-fns';
import apiRequest from '@/js/helpers/apiRequest.js';
import notify from '../js/helpers/notify.js';

export default {
  name: 'PopupTeam',

  data() {
    return {
      loading: true,
      phone: '',
      name: '',
      email: '',
      teams: []
    };
  },

  computed: {
    format: () => format
  },

  created() {
    this.getTeams();
  },

  methods: {
    async getTeams() {
      try {
        const res = await apiRequest('team', 'GET', null, true);

        this.loading = false;

        if (res.success) {
          this.teams = res.success.map((item) => ({
            ...item,
            amountValue: ''
          }));
        }
      } catch (error) {
        this.loading = false;
        console.lgo(error);
      }
    },

    async handleSubmitInvite() {
      try {
        const body = new FormData();
        body.append('email', this.email);
        body.append('name', this.name);
        body.append('phone', this.phone);

        const res = await apiRequest('team/send/request', 'POST', body, true);

        if (res.error) {
          notify({ text: res.error });
        } else if (res.success) {
          notify({ text: res.success });

          this.email = '';
          this.name = '';
          this.phone = '';
        }
      } catch (error) {
        console.log(error);
      }
    },

    async sendCredits() {
      try {
        this.$f7.preloader.show();
        const body = new FormData();
        this.teams.forEach((el) => {
          if (el.amountValue.length) {
            body.append('users[]', el.id);
            body.append('amounts[]', el.amountValue);
          }
        });

        const res = await apiRequest('team/send/payments', 'POST', body, true);

        this.$f7.preloader.hide();

        if (res.success) {
          notify({ text: res.success });
          this.getTeams();

          this.teams.forEach((el) => {
            if (el.amountValue.length) {
              this.teams.find((member) => member.id === el.id).amountValue = '';
            }
          });
        }
      } catch (error) {
        this.$f7.preloader.hide();
        console.log(error);
      }
    },

    onPaymentsUpdate(memberId, amount) {
      this.teams.find((member) => member.id === memberId).amountValue = amount;
    }
  }
};
</script>

<style lang="less">
.popup-team:not(.popup-tablet-fullscreen) {
  @media (min-height: 630px) and (min-width: 630px) {
    --f7-popup-tablet-width: 630px;
    --f7-popup-tablet-height: 500px;
  }

  @media (min-height: 630px) and (min-width: 790px) {
    --f7-popup-tablet-width: 790px;
    --f7-popup-tablet-height: 500px;
  }
}

.popup-team {
  --f7-table-head-font-size: 14px;
  --f7-table-head-text-color: #979797;

  table {
    th {
      letter-spacing: -0.47px;
    }

    tr {
      font-weight: var(--f7-table-head-font-weight);
      letter-spacing: -0.47px;
      border-bottom: 1px solid #979797;
    }

    input {
      max-width: 80px;
      height: 22px;
      border: 1px solid #979797;
      text-align: center;
      font-size: 14px;
    }
  }
}

.popup-team-empty {
  font-weight: 600;
  color: rgba(37, 37, 37, 0.8);
  // font-size: 16px;
}

.popup-team-form {
  display: flex;
  align-items: center;

  --f7-list-item-min-height: auto;
  --f7-list-item-padding-horizontal: 0;
  --f7-list-item-padding-vertical: 0;
  --f7-input-outline-padding-horizontal: 20px;

  ul {
    display: flex;
  }

  li {
    border: 1px solid #979797;
    flex-basis: 100%;

    &:not(:last-of-type) {
      margin-right: 10px;
    }
  }

  .button {
    flex-shrink: 0;
    margin-left: 15px;
  }
}
</style>
